const DEFAULT_TRUNK_HEIGHT = 10;
const SHORT_TREE_HEIGHT = 30;

export const getDefaultTrunkHeight = (height) =>
  Number.isFinite(height) && height < SHORT_TREE_HEIGHT
    ? height / 4
    : DEFAULT_TRUNK_HEIGHT;
